import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useLocation } from 'react-router-dom'
import { Button } from '@mui/material'
import PrintIcon from '@mui/icons-material/Print'
import { useSelector } from 'react-redux'
import PrintDialog from 'components/generic/printable/PrintDialog'
import PrintablePackingListOrBoL from 'components/generic/printable/PrintablePackingListOrBoL'
import ConfirmationScreen from 'components/generic/confirmation-screen'

const PackingListCreatedContainer = ({ onHideModal }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const packingList = useSelector(state => state.ui.formModalProps)
  const [showPrintModal, setShowPrintModal] = useState(false)

  const handleOpenPrintDialog = () => setShowPrintModal(true)

  const handleClosePrintDialog = () => setShowPrintModal(false)

  const actionButtonList = () => (
    <>
      <Button variant="outlined" onClick={handleOpenPrintDialog} startIcon={<PrintIcon />}>
        Print
      </Button>
      <Button
        onClick={() => {
          const inventoryPath = location.pathname.split('/').slice(0, -1).join('/')

          onHideModal()
          navigate(inventoryPath)
        }}
        variant="contained"
      >
        Finish
      </Button>
    </>
  )

  return (
    <>
      <ConfirmationScreen title="Packing List Created" ActionButtonList={actionButtonList} />

      {showPrintModal && (
        <PrintDialog
          title={`Packing List #${packingList?.tag}`}
          open={showPrintModal}
          onClose={handleClosePrintDialog}
          showLogoAddress
        >
          <PrintablePackingListOrBoL
            overall={{ gross: 0, tare: 0, net: packingList?.net }}
            finishedGoods={packingList?.finishedGoods}
            notes={packingList?.notes?.length > 0 && packingList?.notes[0]}
          />
        </PrintDialog>
      )}
    </>
  )
}

export default PackingListCreatedContainer

PackingListCreatedContainer.propTypes = {
  onHideModal: PropTypes.func,
}

PackingListCreatedContainer.defaultProps = {
  onHideModal: () => {},
}
